import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Magento is a feature-rich, open-source commerce platform built for stores that need scale, flexibility and control. It handles large catalogues, complex pricing and multi-store setups with ease.",
    "We build and customise Magento stores end to end — themes, extensions, integrations and performance — so your store stays fast as it grows.",
];

const FEATURES = [
    { title: "Scalable by design", text: "Handle big catalogues, high traffic and multiple storefronts confidently." },
    { title: "Custom themes & extensions", text: "A store built to your brand and your rules, not a stock layout." },
    { title: "Integrations", text: "ERP, CRM, payments and shipping connected into one smooth operation." },
    { title: "Performance tuning", text: "Caching, optimisation and clean code keep a large store quick." },
];

const CHECKS = [
    "Magento store development",
    "Theme & template design",
    "Custom extension development",
    "Payment & shipping integration",
    "Store migration & upgrades",
];

export default function Magento() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="E-Commerce" title="Magento Development" eyebrowAs="span">
                    Powerful, scalable online stores built on Magento — for catalogues and businesses that need room to grow.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
